/*
 *@Author: 史泽
 *@Date: 2022-01-17 09:58:03
 *@Description: 渠道管理【首页->公司简介->右半部分图片】
*/
<template>
  <div class="CompanyprofileRight">
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.CompanyprofileRight {
//   border: 1px solid red;
  width: 600px;
  height: 100%;
  background: url("../../../../../../../assets/channel/homePng/honeCompany.png") no-repeat 0 0;
}
</style>